// these are only modifiers, not actual options

export const VisibleRadioMapOptions = {
    NONE: 'Active Connections',
    ACTIVE: 'Active Chipsets',
    STANDBY: 'Standby Chipsets',
    ALWAYS: 'All Chipsets',
    SELECTED: 'Selected',
    INFRA: 'Infrastructure',
    MOBILE: 'Mobile Devices',
};
